module.exports = __webpack_public_path__ + "img/pluspay.5d172010.svg";